var _circle, _circle2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgHeartBadge = function SvgHeartBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F8BBD0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12.5,
    stroke: "#18181B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 9a4.79 4.79 0 00-3.6 1.672A4.79 4.79 0 0012.4 9 4.357 4.357 0 008 13.4c0 3.024 2.72 5.488 6.84 9.232L16 23.68l1.16-1.056c4.12-3.736 6.84-6.2 6.84-9.224 0-2.464-1.936-4.4-4.4-4.4zm-3.52 12.44l-.08.08-.08-.08c-3.808-3.448-6.32-5.728-6.32-8.04 0-1.6 1.2-2.8 2.8-2.8 1.232 0 2.432.792 2.856 1.888h1.496c.416-1.096 1.616-1.888 2.848-1.888 1.6 0 2.8 1.2 2.8 2.8 0 2.312-2.512 4.592-6.32 8.04z",
    fill: "#27272A"
  })));
};

export default SvgHeartBadge;